export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  // {
  //   text: that.$l('menu_text_edit') || '编辑单据',
  //   icon: 'el-icon-edit',
  //   menuType: 'edit',
  //   divided: true,
  //   allow: 'M',
  //   disabled: ({ amzFtyOutboundStatus }) => amzFtyOutboundStatus !== 'N',
  // },
  {
    text: that.$l('menu_text_delete') || '删除单据',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    allow: 'D',
    disabled: ({ amzFtyOutboundStatus }) => amzFtyOutboundStatus !== 'N',
  },
  {
    text: that.$l('menu_text_audit') || '审核通过',
    icon: 'el-icon-chat-dot-square',
    menuType: 'audit',
    divided: false,
    allow: 'C',
    disabled: ({ amzFtyOutboundStatus }) => amzFtyOutboundStatus !== 'N',
  },
]
